import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import '@cian/ui-kit-design-tokens/colors/deprecated/variables.module.css';
import '@cian/ui-kit-design-tokens/colors/semanticPalette.css';
import * as React from 'react';
import { UiKitContextProvider } from '../context';
import { Theme } from '../theme';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Эта компонента обязательно должна быть в корне приложения
 *
 * Без неё кит может не работать
 */
export function UiKitRoot(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    contextProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(UiKitContextProvider, _objectSpread(_objectSpread({}, contextProps), {}, {
    children: /*#__PURE__*/_jsx(Theme, {
      theme: theme,
      children: children
    })
  }));
}